import { Flex } from '@grubhubprod/gh-cookbook-react/dist';
import get from 'lodash/get';
import React, { ReactNode } from 'react';
import {
  FormInput,
  Label,
  IFormInputProps,
  DropdownProps,
  Dropdown,
} from '@grubhubprod/gh-cookbook-react';
import { Control, RegisterOptions, useController } from 'react-hook-form';

export interface DropdownOptionProps {
  value: string;
  text: string;
}

export type CookbookSelectWrapperBaseProps = {
  name: string;
  id: string;
  control: Control;
  rules?: RegisterOptions;
  label?: ReactNode;
  ariaLabel?: string;
  options: DropdownOptionProps[];
  maxHeight?: string;
};

export type CookbookSelectWrapperProps = Omit<
  DropdownProps,
  'value' | 'onSelect' | 'error' | 'label'
> &
  CookbookSelectWrapperBaseProps &
  Pick<IFormInputProps, 'inputSize' | 'blockWidth' | 'error'>;

export function CookbookSelectWrapper({
  name,
  id,
  control,
  rules = {},
  error,
  ariaLabel,
  label = '',
  maxHeight = '300px',
  inputSize = 'medium',
  blockWidth,
  disabled,
  options,
  ...cookbookDropdownProps
}: CookbookSelectWrapperProps): JSX.Element {
  const { field } = useController({
    name,
    rules,
    control,
    defaultValue: get(control.defaultValuesRef.current, name) ?? '',
  });

  return (
    <FormInput inputSize={inputSize} blockWidth={blockWidth} error={error}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Flex flexDirection="column">
        <Dropdown
          {...cookbookDropdownProps}
          disabled={disabled}
          aria-label={label}
          {...(ariaLabel && { 'aria-label': ariaLabel })}
          multiple={false}
          block={blockWidth}
          error={!!error}
          id={id}
          value={field.value}
          onSelect={field.onChange}
          options={options}
          selectionPaneProps={{
            maxHeight,
          }}
        />
      </Flex>
    </FormInput>
  );
}
